/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_LabelInputs */

const cs_billing_plan_label = /** @type {(inputs: Billing_Plan_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif`)
};

const en_billing_plan_label = /** @type {(inputs: Billing_Plan_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Billing_Plan_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_label = /** @type {((inputs?: Billing_Plan_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_label(inputs)
	return cs_billing_plan_label(inputs)
});